import pt from "./pt";
import en from "./en";
import es from "./es";
import ja from "./ja";
import { useLang } from "./LangContext";

const translations = { pt, en, es, ja };

export function useT() {
  const { lang } = useLang();
  return translations[lang] || translations.pt;
}

export { LangProvider, useLang, LANGUAGES } from "./LangContext";
